export const pathSeparatorChar = "/";
